export type DaySchedule = {
    enabled: boolean
    startTime: string // Format: "08:00 AM"
    endTime: string // Format: "06:00 PM"
}

export type WeeklySchedule = {
    sun: DaySchedule
    mon: DaySchedule
    tue: DaySchedule
    wed: DaySchedule
    thu: DaySchedule
    fri: DaySchedule
    sat: DaySchedule
}

export type SequenceStep = {
    id: string
    type: 'email' | 'sms'
    subject?: string
    message?: string
    content_html?: string
    schedule?: WeeklySchedule
    condition?: any
    guest_card?: number | null
    pendingFiles?: File[]
}

export type DelayStep = {
    id: string
    type: 'delay'
    days: number
}

export type SequenceItem = SequenceStep | DelayStep

export type CampaignData = {
    name: string
    channels: {
        email: boolean
        sms: boolean
    }
    cta: string
    reply_to_email: string
    sender_name: string
    concessions?: number[]
}

export type ProspectList = {
    id: string
    name: string
    prospects: number
}

export type CTAOption = {
    value: string
    label: string
}

export const TIME_OPTIONS = [
    '12:00 AM',
    '12:30 AM',
    '01:00 AM',
    '01:30 AM',
    '02:00 AM',
    '02:30 AM',
    '03:00 AM',
    '03:30 AM',
    '04:00 AM',
    '04:30 AM',
    '05:00 AM',
    '05:30 AM',
    '06:00 AM',
    '06:30 AM',
    '07:00 AM',
    '07:30 AM',
    '08:00 AM',
    '08:30 AM',
    '09:00 AM',
    '09:30 AM',
    '10:00 AM',
    '10:30 AM',
    '11:00 AM',
    '11:30 AM',
    '12:00 PM',
    '12:30 PM',
    '01:00 PM',
    '01:30 PM',
    '02:00 PM',
    '02:30 PM',
    '03:00 PM',
    '03:30 PM',
    '04:00 PM',
    '04:30 PM',
    '05:00 PM',
    '05:30 PM',
    '06:00 PM',
    '06:30 PM',
    '07:00 PM',
    '07:30 PM',
    '08:00 PM',
    '08:30 PM',
    '09:00 PM',
    '09:30 PM',
    '10:00 PM',
    '10:30 PM',
    '11:00 PM',
    '11:30 PM',
] as const
